import type {
  FilterType,
  NavItem,
  StatusFilterType,
} from '../types/dashboard.types';

export const SIDEBAR_WIDTH = 280;
export const SIDEBAR_WIDTH_COLLAPSED = 72;
export const BOTTOM_NAV_HEIGHT = 80;
export const MOBILE_HEADER_HEIGHT = 64;
export const MOBILE_BREAKPOINT = 768;
export const ITEMS_PER_PAGE = 7;
export const GLOBAL_HEADER_HEIGHT = 56;

export const NAV_ITEMS: NavItem[] = [
  {
    key: 'dashboard',
    labelKey: 'nav.dashboard',
    icon: 'layout-dashboard',
    path: '/dashboard',
  },
  {
    key: 'pipeline',
    labelKey: 'nav.pipeline',
    icon: 'columns-3',
    path: '/dashboard/pipeline',
  },
  {
    key: 'renewals',
    labelKey: 'nav.renewals',
    icon: 'calendar-clock',
    path: '/dashboard/renewals',
  },
  {
    key: 'forms',
    labelKey: 'nav.forms',
    icon: 'file-text',
    path: '/dashboard/forms',
  },
  {
    key: 'clients',
    labelKey: 'nav.clients',
    icon: 'users',
    path: '/dashboard/clients',
  },
  {
    key: 'reports',
    labelKey: 'nav.crmReports',
    icon: 'bar-chart-3',
    path: '/dashboard/reports',
  },
  {
    key: 'notifications',
    labelKey: 'nav.notifications',
    icon: 'bell',
    path: '/dashboard/notifications',
  },
  {
    key: 'settings',
    labelKey: 'nav.settings',
    icon: 'settings',
    path: '/dashboard/settings',
  },
];

export const MOBILE_NAV_ITEMS: NavItem[] = [
  {
    key: 'dashboard',
    labelKey: 'nav.dashboard',
    icon: 'layout-dashboard',
    path: '/dashboard',
  },
  {
    key: 'forms',
    labelKey: 'nav.forms',
    icon: 'file-text',
    path: '/dashboard/forms',
  },
  {
    key: 'settings',
    labelKey: 'nav.settings',
    icon: 'settings',
    path: '/dashboard/settings',
  },
];

export const FILTER_OPTIONS: { key: FilterType; labelKey: string }[] = [
  { key: 'all', labelKey: 'dashboard.filters.all' },
  { key: 'auto', labelKey: 'dashboard.filters.auto' },
  { key: 'life', labelKey: 'dashboard.filters.life' },
  { key: 'disability', labelKey: 'dashboard.filters.disability' },
  { key: 'home', labelKey: 'dashboard.filters.home' },
];

export const STATUS_FILTER_OPTIONS: {
  key: StatusFilterType;
  labelKey: string;
}[] = [
  { key: 'active', labelKey: 'dashboard.statusFilter.active' },
  { key: 'completed', labelKey: 'dashboard.statusFilter.completed' },
];

export const STATUS_COLORS = {
  completed: {
    bg: 'bg-status-completed-bg',
    text: 'text-status-completed-text',
  },
  pending: {
    bg: 'bg-status-pending-bg',
    text: 'text-status-pending-text',
  },
  declined: {
    bg: 'bg-status-declined-bg',
    text: 'text-status-declined-text',
  },
} as const;

export const TYPE_COLORS = {
  auto: {
    bg: 'bg-type-auto-bg',
    text: 'text-type-auto',
  },
  life: {
    bg: 'bg-type-life-bg',
    text: 'text-type-life',
  },
  disability: {
    bg: 'bg-type-disability-bg',
    text: 'text-type-disability',
  },
  home: {
    bg: 'bg-type-home-bg',
    text: 'text-type-home',
  },
} as const;

export const TYPE_ICONS = {
  auto: 'car',
  life: 'heart',
  disability: 'accessibility',
  home: 'home',
} as const;
